export default "__VITE_ASSET__K9t6bn02__"